webpackJsonp([149847447984264],{

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clientsRightsContentModule = __webpack_require__(49);
	
	var _clientsRightsContentModule2 = _interopRequireDefault(_clientsRightsContentModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Reporting = function Reporting() {
	  return _react2.default.createElement(
	    'div',
	    { className: _clientsRightsContentModule2.default.clientsRightsContainer },
	    _react2.default.createElement(
	      'div',
	      { className: _clientsRightsContentModule2.default.section },
	      _react2.default.createElement(
	        'h4',
	        { className: _clientsRightsContentModule2.default.boldheader },
	        'SEC Rule 606 Report: Percentages of Total Non-Directed Orders Routed to Venues'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _clientsRightsContentModule2.default.section },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Empire Asset Management has prepared this report pursuant to U.S. Securities and Exchange Commission Rule 606, formerly Rule 11A(c)1-6, requiring all brokerage firms to make publicly available quarterly reports on their order routing practices. The report provides information on the routing of non-directed orders, which are any orders that the customer has not specifically instructed to be routed to a particular venue for execution.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _clientsRightsContentModule2.default.section },
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'https://public.s3.com/rule606/rbcwm/correspondentsvcs',
	          target: '_blank'
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          'View 606 Report'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _clientsRightsContentModule2.default.section },
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'https://github.com/gregRV/eam-site/blob/master/Disclosure%20of%20Order%20Routing%20Information.pdf?raw=true',
	          target: '_blank'
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Trading Disclosures'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _clientsRightsContentModule2.default.section },
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'h4',
	          { className: _clientsRightsContentModule2.default.boldheader },
	          'Customer Relationship Summary:'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _clientsRightsContentModule2.default.section },
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'https://github.com/gregRV/eam-site/blob/master/Empire%20CRS%20BD%202021.pdf?raw=true',
	          target: '_blank', type: 'application/pdf'
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Empire Asset Management Company'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _clientsRightsContentModule2.default.section },
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'https://github.com/eam18/eam-site/blob/master/Empire%20CRS%20IA%20(05-28-2026).pdf?raw=true',
	          target: '_blank'
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Empire Financial Management Company'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Reporting;
	module.exports = exports['default'];

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ButtonGroup = __webpack_require__(37);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _Reporting = __webpack_require__(145);
	
	var _Reporting2 = _interopRequireDefault(_Reporting);
	
	var _clientsRightsModule = __webpack_require__(50);
	
	var _clientsRightsModule2 = _interopRequireDefault(_clientsRightsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Reporting = function Reporting() {
	  return _react2.default.createElement(
	    'div',
	    { className: _clientsRightsModule2.default.clientsRightsContainer },
	    _react2.default.createElement(_ButtonGroup2.default, {
	      a: { label: 'Clients Rigths & Protections', to: '/clients-rights', isActive: false },
	      b: { label: 'Business Continuity Plan', to: '/business-continuity-plan', isActive: false },
	      x: { label: 'Privacy Policy', to: '/privacy-policy', isActive: false },
	      y: { label: '606 Reports / Form CRS', to: '/reporting', isActive: true }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _clientsRightsModule2.default.stdContent },
	      _react2.default.createElement(_Reporting2.default, null)
	    )
	  );
	};
	
	exports.default = Reporting;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-reporting-js-a6b7122e0fd6be0cd41d.js